'use client';

import { c as _c } from "react/compiler-runtime";
import { CustomSelection } from '@/app/lcv/components/sections/calculator/configure/custom-selection';
import type { CalculatorConfigProps } from '@/app/lcv/components/sections/calculator/types';
import { CompareListColorPicker } from '@/app/lcv/components/sections/compare/list/header-cta/color-picker';
import { getLcvCategoryFromLcvModel } from '@/app/lcv/components/sections/compare/utils';
import { formatPrice } from '@/app/utils/format';
import { safeCall } from '@/app/utils/safeCall';
import type { LcvModelColor } from '@/types/tis-cms/types';
interface ColorSelectionProps {
  isOpen: boolean;
  toggle: () => void;
  model: CalculatorConfigProps['model'];
  colors?: LcvModelColor[];
  color?: LcvModelColor;
  onSelectColor?: (color: LcvModelColor) => void;
}
const ColorNamePanel = t0 => {
  const $ = _c(5);
  const {
    color,
    onToggle
  } = t0;
  let t1;
  if ($[0] !== color || $[1] !== onToggle) {
    t1 = !!color && <p className="w-full" onClick={onToggle}>{`${color?.color?.nameTh ?? ""}${(color?.price ?? 0) !== 0 ? ` +${formatPrice(color?.price ?? 0, "none")}` : ""}`}</p>;
    $[0] = color;
    $[1] = onToggle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <>{t1}</>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const ColorSelection = t0 => {
  const $ = _c(28);
  const {
    isOpen,
    toggle,
    color,
    colors,
    model,
    onSelectColor
  } = t0;
  let t1;
  if ($[0] !== onSelectColor) {
    t1 = selectedColor => {
      safeCall(onSelectColor, selectedColor);
    };
    $[0] = onSelectColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onColorChange = t1;
  let t2;
  if ($[2] !== color || $[3] !== toggle) {
    t2 = <ColorNamePanel color={color} onToggle={toggle} />;
    $[2] = color;
    $[3] = toggle;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== colors || $[6] !== model.colors) {
    t3 = colors ?? model.colors ?? [];
    $[5] = colors;
    $[6] = model.colors;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = t3.filter(_temp);
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== model.name || $[11] !== model.subCategory || $[12] !== t4) {
    t5 = {
      colors: t4,
      name: model.name,
      subCategory: model.subCategory
    };
    $[10] = model.name;
    $[11] = model.subCategory;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== model) {
    t6 = getLcvCategoryFromLcvModel(model) ?? model.category;
    $[14] = model;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== onColorChange) {
    t7 = selectedColor_0 => {
      if (selectedColor_0) {
        onColorChange(selectedColor_0);
      }
    };
    $[16] = onColorChange;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== color || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
    t8 = <CompareListColorPicker containerClassName="items-start gap-y-2" chipSize="md" model={t5} category={t6} selectedColor={color} onSelectColor={t7} />;
    $[18] = color;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== isOpen || $[24] !== t2 || $[25] !== t8 || $[26] !== toggle) {
    t9 = <div className="cursor-pointer"><CustomSelection test="model-color" title={"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E35"} value="accordion-color" selectedValue={t2} isOpen={isOpen} onChange={toggle} content={t8} /></div>;
    $[23] = isOpen;
    $[24] = t2;
    $[25] = t8;
    $[26] = toggle;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
};
function _temp(item) {
  return !!item;
}